import React from 'react';
import './AboutUs.css';
import paris from '../assets/pb1.jpg';

const AboutUs = () => {
    return (
        <div className="about-container">
            <h1 className="about-title">About Ninja Bakers</h1>
            <p className="about-subtitle">Transforming Restaurant and Bakery Experiences with AI-Powered Efficiency</p>

            <div className="about-section">
                <img
                    src={paris}
                    alt="Vision"
                    className="about-image"
                />
                <div className="about-text">
                    <section className="mt-8 bg-white p-6 rounded-lg shadow-md">
                        <h2 className="text-2xl font-semibold text-gray-800">Our Vision</h2>
                        <p className="text-lg text-gray-700 mt-2">
                            At Ninja Bakers, we believe in empowering restaurants and bakeries with innovative technology solutions.
                            Our mission is to simplify operations, reduce food wastage, and enhance productivity through data-driven insights.
                            By leveraging AI-driven predictions and smart inventory management, we help businesses achieve profitability by
                            minimizing food wastage and optimizing inventory—saving up to <span className="text-green-600 font-bold">$30,000</span>
                            /month. Our vision is to revolutionize the food industry, making it more efficient, sustainable, and profitable.
                        </p>
                    </section>
                </div>
            </div>

            <div className="about-section">
                <div className="about-text">
                    <h2>Why Choose Ninja Bakers?</h2>
                    <ul>
                        <li>⚡ Efficient Order Management</li>
                        <li>📊 Accurate Food Wastage Predictions</li>
                        <li>🚀 Streamlined Inventory Control</li>
                        <li>📈 Business Insights for Growth</li>
                    </ul>
                    <p>
                        Our AI-powered solutions are tailored to meet the unique needs of bakeries and restaurants, helping you
                        make data-driven decisions to maximize profits and minimize wastage.
                    </p>
                </div>
                {/* <img
                    src="/images/team.jpg"
                    alt="Team"
                    className="about-image"
                /> */}
            </div>

            <div className="about-mission">
                <h2>Our Mission</h2>
                <p>
                    Our mission is to transform the food service industry by leveraging cutting-edge technology that brings
                    operational efficiency, reduces waste, and drives profitability for our clients.
                </p>
            </div>
        </div>
    );
};

export default AboutUs;
